// extracted by mini-css-extract-plugin
module.exports = {"header":"Dashboard_header__vYzYi","trisect":"Dashboard_trisect__shRx3"};